

















































































































































































































































































































































































import { Component, Mixins } from "vue-property-decorator";
import { CommonFormService } from "../service/common-form.service";
import { CommonForm } from "../models/common-form";
import { ProviderNotificationData } from "../models/notification-data";
import { ContentService } from "@/service/content.service";
import { ParentPageContent } from "@/models/content/parent-page";
import CommonMixin from "@/mixins/common-mixins";
import { CommonContent } from "@/models/content/common";
import moment from 'moment'
@Component({
  components: {},
})
export default class Parent extends Mixins(CommonMixin) {
  commonFormService = new CommonFormService();
  content: ParentPageContent = {} as ParentPageContent;
  commonContent: CommonContent = {} as CommonContent;
  commonForm = {} as CommonForm;
  commonFormLoaded = false;
  haveBadToken = false;
  notificationData: Array<ProviderNotificationData> = [];
  numberOfMatches = 0;
  textDirection = "ltr";
  token = "";
  pdfToken = "";

  async mounted(): Promise<void> {
    try {
      const contentService = new ContentService(this.$route);
      this.content = await contentService.getParentPageContent();
      this.commonContent = await contentService.getCommonContent();
      this.textDirection = contentService.TextDirection();
      this.token = this.$route.params.token;
      const secure = await this.commonFormService.getParent(this.token);
      if (secure != null) {
        this.commonForm = secure.commonForm;
        this.notificationData = secure.notificationData;
        this.pdfToken = secure.pdfToken;
      }
      this.commonFormLoaded = true;
    } catch (error) {
      if (error.response.status === 422) {
        this.haveBadToken = true;
      }
    }
  }

  async downloadPdfClick(): Promise<void> {
    //const blob = await this.commonFormService.foo2();
    const blob = await this.commonFormService.getParentPDFBuffer(this.pdfToken);
    if (blob != null) {
      const link = document.createElement("a");
      //link.href = URL.createObjectURL(blob);
      link.href = `data:application/pdf;base64,${blob}`;
      link.download = "Your-Connect4Care-Kids-Information.pdf";
      link.click();
      URL.revokeObjectURL(link.href);
    }
  }

  CountSiteMatches(): void {
    let siteCount = 0;
    this.notificationData.forEach((p) => {
      // Add to the site count
      siteCount += p.sites.length;
    });

    this.numberOfMatches = siteCount;
  }

  get languages(): string {
    const languages = [];
    if (this.commonForm.caregiver.speakenglish === true) {
      languages.push(this.content.English);
    }
    if (this.commonForm.caregiver.speakspanish === true) {
      languages.push(this.content.Spanish);
    }
    if (this.commonForm.caregiver.speakarabic === true) {
      languages.push(this.content.Arabic);
    }
    if (this.commonForm.caregiver.speakother === true) {
      languages.push(this.commonForm.caregiver.otherlanguage);
    }
    return languages.join(" ");
  }

  get formCompletedLanguage(): string {
    if (this.commonForm.language === "es") {
      return this.content.Spanish;
    } else if (this.commonForm.language === "ar") {
      return this.content.Arabic;
    } else {
      return this.content.English;
    }
  }

  get maritalStatus(): string {
    if (this.commonForm.caregiver.maritalstatus === "Married") {
      return this.content.Married;
    } else if (this.commonForm.caregiver.maritalstatus === "Single") {
      return this.content.Single;
    } else {
      return this.content.Divorced;
    }
  }

  get phoneNumber(): string {
    let phoneNumber = "";
    if (this.commonForm != null && this.commonForm.caregiver != null) {
      phoneNumber = this.commonForm.caregiver.phonenumber ?? '';
      const numbersOnly = phoneNumber.replace(/\D/g, "");
      if (numbersOnly.length == 10) {
        phoneNumber = numbersOnly
          .replace(/[^0-9()-]/g, "")
          .replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
      }
    }
    return phoneNumber;
  }


 get formSubmittedDate(): string {
    if ( this.commonForm.modifieddate != null) {
        return  moment(this.commonForm.modifieddate).format('MM/DD/YYYY');
    }
    return ''
  }

  /*

  async downloadPdfClick() {
      //const pdfData = await this.commonFormService.getParentPdf(this.token);
      //const hrefData = `data:application/octet-stream,${pdfData}`;
  }
  */
}
